import {
  MDBAlert,
  MDBBtn,
  MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle,
  MDBSpinner,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState, useImperativeHandle, forwardRef } from "react";
import { useNavigate } from "react-router";
import AddSMSCampaign from "../../components/topviews/addSMSCampaign";
import {
  deleteSMSDraft,
  getMisc,
  getSMSCampaign,
  getSMSCampaignDraft,
  getSpecificSMSCampDetails,
  handleOpenDraft,
} from "../../apiclients/streamsapi_bridge";
import DeleteSMSCampaign from "../popups/globalaccount/brandAndSMS/DeleteSMSCampaign";
import PopupLoaderNew from "../popups/PopupLoaderNew";
import { Tooltip } from "react-tooltip";
import SmsCompliance from "./SmsCompliance";
import { useTranslation } from "react-i18next";
import UIConstant from "../../apiclients/UIConstant";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../components/CustomSearchUtil/CustomSearch";
import TabIDConstant from "../../apiclients/TabIDConstant";

const CampaignDraft = forwardRef(({ basicActive }, ref) => {
  const navigate = useNavigate();
  const [centredModal4, setCentredModal4] = useState(false);

  const toggleOpen4 = () => {
    // If closing modal, restart polling if needed
    if (centredModal4) {
      // Modal is closing - check if we need to restart polling
      getSMSdraft();
    } else {
      // Modal is opening - stop polling
      clearPolling();
    }
    setCentredModal4(!centredModal4);
  };
  const [internalError, setInternalError] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [SMSCampaigns, setSMSCampaigns] = useState([]);
  const [deleteCampaign, setdeleteCampaign] = useState(false);
  const deletetoggle = () => setdeleteCampaign(!deleteCampaign);
  const [campaignObj, setcampaignObj] = useState({});
  const [isLoading, setisLoading] = useState(false);
  const deletCampRef = useRef(null);
  const [draftDetails, setdraftDetails] = useState({});
  const [isDraft, setisDraft] = useState(false);
  const [brandMiscInfo, setbrandMiscInfo] = useState({});
  const [smsDraftDetails, setSmsDraftDetails] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const searchRef = useRef(null);
  const { t, i18n } = useTranslation();

  // Add ref to store the polling timer
  const pollingTimerRef = useRef(null);

  // Ref to store previous drafts for polling comparison (initial or last polled result)
  const previousDraftsRef = useRef(null);
  // Success message state for "Creation On Progress" records that got completed
  const [successMessage, setSuccessMessage] = useState("");
  // Ref to manage the success message auto-hide timer manually
  const successTimerRef = useRef(null);

  // Show success message and (re)start the 10-second auto-hide timer
  const showSuccessMessage = (msg) => {
    if (successTimerRef.current) {
      clearTimeout(successTimerRef.current);
    }
    setSuccessMessage(msg);
    successTimerRef.current = setTimeout(() => {
      setSuccessMessage("");
      successTimerRef.current = null;
    }, 10000);
  };

  useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, basicActive);

  // SMS Status Alert states
  function handleClick() {
    deletCampRef.current.click();
  }

  const showThisInfoSms = (tdata) => {
    if (!(tdata?.campInfo?.status?.toString() === "Saved As Draft")) {
      navigate("/smscampaignregistration", {
        state: tdata.campInfo,
      });
    }
  };

  // Check if any campaign has "Creation On Progress" status
  const hasInProgressCampaign = (campaigns) => {
    return campaigns.some((camp) => camp?.status === "Creation On Progress");
  };

  // Clear polling timer
  const clearPolling = () => {
    if (pollingTimerRef.current) {
      clearTimeout(pollingTimerRef.current);
      pollingTimerRef.current = null;
    }
  };

  // Expose clearPolling to parent component
  useImperativeHandle(ref, () => ({
    clearPolling
  }));

  // Start polling if needed
  const startPollingIfNeeded = (campaigns) => {
    clearPolling(); // Clear any existing timer

    if (hasInProgressCampaign(campaigns)) {
      pollingTimerRef.current = setTimeout(() => {
        // Check if tab is still active before polling
        if (basicActive) {
          getSMSdraft(true);
        }
      }, 10000); // 10 seconds
    }
  };

  useEffect(() => {
    if (basicActive) {
      getSMSdraft();
    } else {
      // Stop polling when tab becomes inactive
      clearPolling();
    }

    // Cleanup on unmount
    return () => {
      clearPolling();
      if (successTimerRef.current) {
        clearTimeout(successTimerRef.current);
      }
    };
  }, [basicActive]);

  async function getSMSdraft(reload) {
    try {
      if (!reload) {
        setInternalError(false);
        setIsloading(true);
      }
      console.log(sessionStorage.getItem("admin_session"));
      const response = await getSMSCampaignDraft(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      if (!reload) {
        setIsloading(false);
      }
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      const rawData = await response.json();
      if (!rawData) {
        setInternalError(true);
      }
      console.log("getSMSCampaigns data :::::::::: " + JSON.stringify(rawData));
      const drafts = rawData?.drafts ?? [];

      // During polling, detect "Creation On Progress" records that disappeared
      if (reload && previousDraftsRef.current !== null) {
        const currentIds = new Set(drafts.map((d) => d.id));
       const completedBrands = previousDraftsRef.current
         .filter(
           (d) => d.status === "Creation On Progress" && !currentIds.has(d.id),
         )
         .map((d) => `'${d.brand_name}'`);
        if (completedBrands.length > 0) {
          const brandText = completedBrands.length > 1 ? "brands" : "brand";

          showSuccessMessage(
           `The ${brandText} ${completedBrands.join(", ")} has been successfully submitted for review. Please visit the Brands page to see the details.`
        );
        }
      }
      // Update previous drafts ref after each fetch
      previousDraftsRef.current = drafts;

      setSMSCampaigns(drafts);

      // Start polling if any campaign is in progress (and tab is active)
      if (basicActive) {
        startPollingIfNeeded(drafts);
      }

      setTimeout(() => {
        setIsloading(false);
      }, 1000);
    } catch (error) {
      console.error("Error fetching SMS drafts:", error);
      setIsloading(false);
    }
  }

  async function handleDaft(camp) {
    try {
      if (camp.campInfo.draft_type === 1) return;
      
      // STOP POLLING IMMEDIATELY
      clearPolling();
      
      setIsloading(true);
      const response = await handleOpenDraft(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        camp.campInfo.id
      );
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      const campDetails = await response.json();
      console.log("getSpecific campDetails ::: " + JSON.stringify(campDetails));
      setisDraft(true);
      setdraftDetails(campDetails?.data ?? {});
      await fetchData(camp.campInfo.id);
    } catch (error) {
      console.error("Error handling draft:", error);
    }
  }

  async function fetchData(draftid) {
    // STOP POLLING when modal opens
    clearPolling();
    
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["brand_cmpg_mics"], draftId: draftid }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with ID not found`);
      // navigate("/");
    }
    setbrandMiscInfo(tdata.misc.brand_cmpg_mics);
    toggleOpen4();
  }

  const handleManualSearch = (searchValue) => {
    setSearchValue(searchValue);
    const filtered = customSearch(
      smsDraftDetails,
      searchValue,
      UIConstant.CAMPAIGNDRAFT
    );
    setFilteredRows(filtered);
  };

  useEffect(() => {
    let processdrows = [];
    SMSCampaigns.map((camp) => {
      processdrows.push({
        campInfo: camp,
        brandname: camp?.brand_name?.toString() ?? "",
        campaignname: camp?.camp_name?.toString() ?? "",
        status:
          camp?.status === "Creation Failed" ? (
            <h6 className="fw-bold" style={{ color: "red" }}>
              Failed - Website Verification
            </h6>
          ) : camp?.status === "Creation On Progress" ? (
            <p className="fw-bold text-primary">
              In Progress - Website Verification
              <MDBSpinner
                color="primary"
                size="sm"
                role="status"
                className="ms-2"
              />
            </p>
          ) : (
            <h6 className="fw-bold">Saved as Draft</h6>
          ),
        added_on: camp?.added_on?.toString() ?? "",
        action: (
          <>
            <div className="d-flex align-items-center ms-2">
              {camp?.draft_type !== 1 && (
                <div
                  className="custom-hover-bg p-1 ms-2 cursor-pointer deleteToolTip"
                  onClick={(e) => handleDelete(e, camp)}
                >
                  <MDBIcon
                    fas
                    icon="times"
                    color="primary"
                    className="mx-2 my-1 fs-5"
                  />
                </div>
              )}
            </div>
          </>
        ),
      });
    });
    setFilteredRows(processdrows);
    setSmsDraftDetails(processdrows);
    setDataLoaded(true);
  }, [SMSCampaigns]);

  const basicData = {
    columns: [
      { label: "Brand Name", field: "brandname", sort: true },
      { label: "Campaign Name", field: "campaignname", sort: true },
      { label: "Status", field: "status", sort: false },
      { label: "Created On", field: "added_on", sort: true },
      { label: "Remove", field: "action", sort: false },
    ],
    rows: smsDraftDetails,
  };

  useEffect(() => {
    const patchTitles = () => {
      const tds = document.querySelectorAll("table td, table th");
      tds.forEach((td) => {
        const trimmed = td.textContent.trim();
        if (!td.getAttribute("title") || td.getAttribute("title") !== trimmed) {
          td.setAttribute("title", trimmed);
        }
      });
    };

    patchTitles();

    const table = document.querySelector(".smsDraftDataTable ");

    if (!table) return;

    const observer = new MutationObserver(() => {
      patchTitles();
    });

    observer.observe(table, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  function handleDelete(e, campObj) {
    e.preventDefault();
    e.stopPropagation();
    
    // STOP POLLING IMMEDIATELY
    clearPolling();
    
    setcampaignObj(campObj);
    deletetoggle();
  }

  async function removeThisDraft(e) {
    try {
      // STOP POLLING IMMEDIATELY (in case it wasn't stopped)
      clearPolling();
      
      setInternalError(false);
      setisLoading(true);
      let deleteGrpReponse = await deleteSMSDraft(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        campaignObj.id
      );
      setTimeout(() => {
        setisLoading(false);
      }, 500);
      let delInfo = await deleteGrpReponse.json();

      if (delInfo.status == "success") {
        localStorage.setItem("s_message", delInfo.message);
        deletetoggle();
      } else {
        localStorage.setItem("f_message", delInfo.message);
        // window.location.href = "/smslanding";
      }
      navigate("/smslanding", {
        state: { tab: "tab3" },
      });
      window.location.reload();
    } catch (e) {
      console.log(`Unable to process Request :Internal server Error:!`);
      setInternalError(true);
    }
  }

  return (
    <>
      <div className="d-flex align-items-center justify-content-between actionbar"></div>
      <div className="mb-2 mt-0 position-relative w-auto">
        <MDBInput
          label="Search"
          value={searchValue}
          ref={searchRef}
          onChange={(e) => handleManualSearch(e.target.value)}
        />
        <MDBIcon fas icon="search" className="MDBDatatable-Search" />
      </div>
      <div className="smsDataTable">
        <MDBDatatable
          // search
          key={searchValue}
          className="actioncolumn smsDraftDataTable"
          data={{ ...basicData, rows: filteredRows }}
          entries={50}
          // sortField="Brand Name"
          onRowClick={(e) => handleDaft(e)}
        />
      </div>

      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}

      <MDBModal
        open={centredModal4}
        onClose={() => setCentredModal4(false)}
        tabIndex="-1"
      >
        <MDBModalDialog size="fullscreen" centered>
          <MDBModalContent>
            <MDBModalBody className="xl p-0">
              <SmsCompliance
                brandMiscInfo={brandMiscInfo}
                draftDetails={draftDetails}
                basicActive = "tab3"
                closePopup={toggleOpen4}
              />
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      {successMessage && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          position="bottom-right"
          onClose={() => {
            if (successTimerRef.current) {
              clearTimeout(successTimerRef.current);
              successTimerRef.current = null;
            }
            setSuccessMessage("");
          }}
        >
          {successMessage}
        </MDBAlert>
      )}

      {internalError && (
        <MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          position="bottom-right"
          delay={5000}
          onClose={() => setInternalError(false)}
        >
          Internal Server Error
        </MDBAlert>
      )}

      {deleteCampaign && (
        <PopupLoaderNew
          title={"Remove SMS Draft"}
          content={
            <>
              <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3 rounded-3 square border border-2 border-danger">
                <MDBIcon
                  fas
                  icon="ban"
                  className="me-3"
                  size="lg"
                  color="danger"
                />
                <span>{t("RemoveSMSDraft")}</span>
              </div>
              <div style={{ display: "none" }}>
                <button
                  ref={deletCampRef}
                  onClick={(e) => {
                    e.preventDefault();
                    removeThisDraft();
                  }}
                >
                  {t("remove")}
                </button>
              </div>
            </>
          }
          onShow={setdeleteCampaign}
          onClose={deletetoggle}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}
        />
      )}
      <Tooltip
        anchorSelect=".deleteToolTip"
        place="top"
        className="exampleTooltip"
      >
        Remove
      </Tooltip>
    </>
  );
});

export default CampaignDraft;